import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components-new/typography/typography';
import Icon from 'components-new/icon/icon';
import type { IconTypes } from 'components-new/icon';
import type Button from 'components-new/button/button';

export interface EmptyStateProps {
  title?: string;
  errorText?: string;
  icon?: IconTypes;
  variant?: 'colorful' | 'default';
  primaryButton?: React.ReactElement<typeof Button>;
  secondaryButton?: React.ReactElement<typeof Button>;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  errorText,
  icon,
  variant = 'default',
  primaryButton,
  secondaryButton,
}) => {
  const fillColor = variant === 'default' ? '#F4F3F4' : '#F5D3DB';

  const iconClassName = twMerge(
    'bg-transparent mx-auto',
    variant === 'default' ? 'text-gray400' : 'text-accent-300',
  );

  return (
    <div className="w-full flex flex-col gap-y-3 p-6 items-center min-w-[192px] max-w-[512px]">
      <div className="relative h-10 w-16 text-center">
        <Icon
          icon={icon || 'custtoysquestion'}
          size={40}
          className={iconClassName}
        />
        <svg
          width="64"
          height="16"
          viewBox="0 0 64 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute bottom-0 -z-10"
        >
          <ellipse cx="32" cy="8" rx="32" ry="8" fill={fillColor} />
        </svg>
      </div>

      {title && (
        <Typography
          variant="heading-2"
          as="span"
          className="text-gray800 text-center"
        >
          {title}
        </Typography>
      )}

      {errorText && (
        <Typography
          variant="body-large"
          as="span"
          className="text-gray600 text-center"
        >
          {errorText}
        </Typography>
      )}
      <div className="flex flex-wrap gap-2 md:gap-5 justify-center">
        {secondaryButton && secondaryButton}
        {primaryButton && primaryButton}
      </div>
    </div>
  );
};

export default EmptyState;
